'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function isString(value) {
  return typeof value === 'string';
}

exports.isString = isString;
//# sourceMappingURL=isString.js.map
